/* global angular */

var logErrorToBackendService = require('aem-libs-angularjs/src/services/log-error-to-backend.service').logErrorToBackendService

angular.module('UniformDetailCmp')
  .factory('logErrorToBackendService', logErrorToBackendService)
  .factory('uniformsService', uniformsService)

uniformsService.$inject = ['$http', 'apiBase', 'apiKey', '$q', 'FileUploader', 'logErrorToBackendService']

function uniformsService ($http, apiBase, apiKey, $q, FileUploader, logErrorToBackendService) {
  var endpointPath = apiBase + 'v3/uniform'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  return {
    getUniformDescription: function (params) {
      return $http({
        url: endpoint('forms/' + params),
        method: 'GET'
      })
        .catch(function (err) {
          logErrorToBackendService.error(JSON.stringify({ err: err }))
        })
    },

    create: function (data) {
      var deferred = $q.defer()

      $http({
        url: endpoint('forms'),
        method: 'POST',
        timeout: deferred.promise,
        cancel: deferred,
        data: data
      }).then(function (result) {
        deferred.resolve(result)
      }, function (err) {
        logErrorToBackendService.error(JSON.stringify({ err: err }))
        deferred.reject(err)
      })
      return deferred.promise
    },

    update: function (data, opportunityID) {
      var deferred = $q.defer()

      $http({
        url: endpoint('forms/' + opportunityID),
        method: 'PUT',
        timeout: deferred.promise,
        cancel: deferred,
        data: data
      }).then(function (result) {
        deferred.resolve(result)
      }, function (err) {
        logErrorToBackendService.error(JSON.stringify({ err: err }))
        deferred.reject(err)
      })
      return deferred.promise
    },

    submit: function (opportunityID) {
      var deferred = $q.defer()

      $http({
        url: endpoint('forms/' + opportunityID + '/submit'),
        method: 'POST',
        timeout: deferred.promise,
        cancel: deferred
      }).then(function (result) {
        deferred.resolve(result)
      }, function (err) {
        logErrorToBackendService.error(JSON.stringify({ err: err }))
        deferred.reject(err)
      })
      return deferred.promise
    },

    getAttachment: function () {
      return new FileUploader({
        url: endpoint('attachment'),
        disableMultipart: true,
        headers: {
          'Content-Type': 'application/octet-stream',
          'WEB-API-key': apiKey
        }
      })
    }
  }
}
